"use client";

import { c as _c } from "react/compiler-runtime";
import React, { useMemo, useRef, useState } from "react";
import { ApiDrop, ApiWave } from "@/generated/models/ObjectSerializer";
import useDeviceInfo from "@/hooks/useDeviceInfo";
import WaveDropsAll from "../drops/wave-drops-all";
import { CreateDropWaveWrapper, CreateDropWaveWrapperContext } from "../CreateDropWaveWrapper";
import { ActiveDropAction, ActiveDropState } from "@/types/dropInteractionTypes";
import PrivilegedDropCreator, { DropMode } from "../PrivilegedDropCreator";
import { useLayout } from "@/components/brain/my-stream/layout/LayoutContext";
import { useAndroidKeyboard } from "@/hooks/useAndroidKeyboard";
interface SingleWaveDropChatProps {
  readonly wave: ApiWave;
  readonly drop: ApiDrop;
}
export const SingleWaveDropChat: React.FC<SingleWaveDropChatProps> = t0 => {
  const $ = _c(36);
  const {
    wave,
    drop
  } = t0;
  const contentWrapperRef = useRef(null);
  const {
    isApp
  } = useDeviceInfo();
  const {
    spaces
  } = useLayout();
  const {
    getContainerStyle,
    isVisible: isKeyboardVisible
  } = useAndroidKeyboard();
  let t1;
  bb0: {
    if (!spaces.measurementsComplete) {
      let t2;
      if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = {};
        $[0] = t2;
      } else {
        t2 = $[0];
      }
      t1 = t2;
      break bb0;
    }
    const t2 = `calc(100vh - ${spaces.headerSpace}px - var(--tab-height, 47px))`;
    let t3;
    if ($[1] !== t2) {
      t3 = {
        height: t2
      };
      $[1] = t2;
      $[2] = t3;
    } else {
      t3 = $[2];
    }
    t1 = t3;
  }
  const containerStyle = t1;
  const t2 = isKeyboardVisible ? "0px" : "calc(env(safe-area-inset-bottom))";
  let t3;
  if ($[3] !== getContainerStyle || $[4] !== t2) {
    t3 = getContainerStyle({
      paddingBottom: t2
    }, 0);
    $[3] = getContainerStyle;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const inputContainerStyle = t3;
  let t4;
  if ($[6] !== drop) {
    t4 = {
      action: ActiveDropAction.REPLY,
      drop,
      partId: 1
    };
    $[6] = drop;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const [activeDrop, setActiveDrop] = useState(t4);
  let t5;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = t6 => {
      const {
        drop: drop_0,
        partId,
        action
      } = t6;
      setActiveDrop({
        action,
        drop: drop_0,
        partId
      });
    };
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  const handleDropAction = t5;
  let t6;
  if ($[9] !== drop) {
    t6 = () => {
      setActiveDrop({
        action: ActiveDropAction.REPLY,
        drop,
        partId: 1
      });
    };
    $[9] = drop;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  const resetActiveDrop = t6;
  const t7 = `tw-flex-1 tw-min-h-0 ${isApp ? "tw-mb-8" : ""}`;
  let t8;
  let t9;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = t10 => {
      const {
        drop: drop_1,
        partId: partId_0
      } = t10;
      return handleDropAction({
        drop: drop_1,
        partId: partId_0,
        action: ActiveDropAction.REPLY
      });
    };
    t9 = t11 => {
      const {
        drop: drop_2,
        partId: partId_1
      } = t11;
      return handleDropAction({
        drop: drop_2,
        partId: partId_1,
        action: ActiveDropAction.QUOTE
      });
    };
    $[11] = t8;
    $[12] = t9;
  } else {
    t8 = $[11];
    t9 = $[12];
  }
  let t10;
  if ($[13] !== activeDrop || $[14] !== drop.id || $[15] !== wave.id) {
    t10 = <WaveDropsAll waveId={wave.id} onReply={t8} onQuote={t9} activeDrop={activeDrop} initialDrop={null} dropId={drop.id} />;
    $[13] = activeDrop;
    $[14] = drop.id;
    $[15] = wave.id;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  let t11;
  if ($[17] !== t10 || $[18] !== t7) {
    t11 = <div className={t7}>{t10}</div>;
    $[17] = t10;
    $[18] = t7;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  let t12;
  if ($[20] !== inputContainerStyle || $[21] !== isApp) {
    t12 = isApp ? inputContainerStyle : {
      paddingBottom: "calc(env(safe-area-inset-bottom))"
    };
    $[20] = inputContainerStyle;
    $[21] = isApp;
    $[22] = t12;
  } else {
    t12 = $[22];
  }
  const t13 = `${isApp ? "tw-fixed tw-bottom-0 tw-left-0 tw-right-0 tw-bg-iron-950 tw-z-10" : "tw-mt-auto"}`;
  let t14;
  if ($[23] !== activeDrop || $[24] !== drop.id || $[25] !== resetActiveDrop || $[26] !== wave) {
    t14 = <CreateDropWaveWrapper context={CreateDropWaveWrapperContext.SINGLE_DROP}><PrivilegedDropCreator activeDrop={activeDrop} onCancelReplyQuote={resetActiveDrop} onDropAddedToQueue={resetActiveDrop} wave={wave} dropId={drop.id} fixedDropMode={DropMode.BOTH} /></CreateDropWaveWrapper>;
    $[23] = activeDrop;
    $[24] = drop.id;
    $[25] = resetActiveDrop;
    $[26] = wave;
    $[27] = t14;
  } else {
    t14 = $[27];
  }
  let t15;
  if ($[28] !== t12 || $[29] !== t13 || $[30] !== t14) {
    t15 = <div style={t12} className={t13}>{t14}</div>;
    $[28] = t12;
    $[29] = t13;
    $[30] = t14;
    $[31] = t15;
  } else {
    t15 = $[31];
  }
  let t16;
  if ($[32] !== containerStyle || $[33] !== t11 || $[34] !== t15) {
    t16 = <div className="tw-flex-1"><div ref={contentWrapperRef} className="tw-h-full tw-overflow-hidden tw-bg-iron-950 tw-relative lg:tw-border lg:tw-border-l-0 lg:tw-border-r lg:tw-border-solid tw-border-iron-900 tw-border-y-0"><div className="tw-relative tw-h-full"><div className="tw-h-full tw-w-full tw-flex tw-items-stretch"><div className="tw-w-full tw-flex tw-flex-col lg:[--tab-height:0px]" style={containerStyle}>{t11}{t15}</div></div></div></div></div>;
    $[32] = containerStyle;
    $[33] = t11;
    $[34] = t15;
    $[35] = t16;
  } else {
    t16 = $[35];
  }
  return t16;
};